import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FormModel} from '../models/FormModel';
import {DeviceDetectorService} from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class BackendService {

  private readonly jsonHttpHeaders: HttpHeaders;
  private baseUrl = 'https://assurancezenith.com:99/devis-api/v2/src/public';
  private urlAuto = this.baseUrl + '/auto';
  private urlDateAndTime = this.baseUrl + '/date-time-infos';

  constructor(private http: HttpClient,  private _deviceService: DeviceDetectorService) {
    this.jsonHttpHeaders =  new HttpHeaders()
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('Accept', 'application/json');
  }
  public saveAutoForm(formModel: FormModel): Observable<any> {
    // return this.http.post<any>(this.urlAuto, formModel, {headers : this.jsonHttpHeaders});
    return this.http.post<FormModel>(this.urlAuto, formModel);
  }
  getDeviceType(): string {
    if (this._deviceService.isDesktop()) { return 'D'; }
    if (this._deviceService.isMobile()) { return 'M'; }
    if (this._deviceService.isTablet()) { return 'T'; }
  }

  public getServerDateAndTime(): Observable<any> {
    // return this.http.get(this.urlDateAndTime, {headers: this.jsonHttpHeaders, responseType: 'json'});
    return this.http.get(this.urlDateAndTime);
  }
  public getParams(url): any {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  }
}
